import { useQuery } from '@tanstack/react-query';
import { UsersService } from '../services';
import { usersKeys } from '../queryKeys';

/**
 * One identity for the Location User profile, from auth-service.
 *
 * `isNotFound` is a settled answer with no user, kept apart from `isError` so
 * the page can tell a mistyped or deleted id from a failed request.
 *
 * `retry: false` and `skipGlobalErrorToaster` because the page renders the
 * failure itself, as the profile's NPS tab does (`useGetNpsReviews`).
 *
 * @param {string} [identityId]
 */
export const useGetLocationUser = (identityId) => {
  const { data, isError, isLoading, isSuccess, refetch } = useQuery({
    queryKey: usersKeys.locationUser(identityId),
    queryFn: () => UsersService.getLocationUser(identityId),
    enabled: Boolean(identityId),
    retry: false,
    refetchOnWindowFocus: false,
    meta: { skipGlobalErrorToaster: true },
  });

  return {
    user: data ?? null,
    isPending: isLoading || !identityId,
    isError,
    isNotFound: isSuccess && !data,
    refetch,
  };
};
